import { useQuery, UseQueryResult } from "react-query";
import { useOrganizationMembership } from "../../authentication/hooks";
import { getConferenceRooms } from "../api";
import { ConferenceRoom } from "../domain";

export function useConferenceRooms(
  floorId: string | null
): UseQueryResult<ConferenceRoom[]> {
  const { organization } = useOrganizationMembership();
  return useQuery(["conference-rooms", organization.id, floorId], () =>
    getConferenceRooms(organization.id, floorId)
  );
}
